var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHappyPuffuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 371,
    height: 473,
    viewBox: "0 0 371 473",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M183.445 397.407V445.87C174.237 453.71 161.488 460.124 144.489 465.113C127.491 470.102 110.492 472.24 92.0765 472.24C65.8701 472.24 44.6217 467.251 28.3312 457.273C9.20765 445.87 0 428.765 0 407.385V108.053C0 101.639 4.24969 94.5121 13.4573 88.0979C22.665 81.6836 35.4141 75.2694 50.9962 69.5678C85.702 57.452 124.657 51.7505 169.279 51.7505C230.191 51.7505 279.063 67.4297 315.893 98.0756C352.724 128.721 370.431 170.058 370.431 222.084C370.431 274.111 354.141 314.022 321.56 343.242C290.395 369.612 246.482 383.153 190.528 383.153C177.779 383.153 164.321 381.728 149.447 378.877C134.573 376.026 125.366 373.175 120.408 371.037C118.991 372.463 117.575 375.313 117.575 378.164C117.575 388.142 139.531 395.269 183.445 397.407Z",
    fill: "#73FF8A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M121.824 160.793C156.247 160.793 184.153 125.693 184.153 82.3963C184.153 39.0992 156.247 4 121.824 4C87.4009 4 59.4954 39.0992 59.4954 82.3963C59.4954 125.693 87.4009 160.793 121.824 160.793Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 7.61272,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M230.9 160.793C265.323 160.793 293.228 125.693 293.228 82.3963C293.228 39.0992 265.323 4 230.9 4C196.476 4 168.571 39.0992 168.571 82.3963C168.571 125.693 196.476 160.793 230.9 160.793Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 7.61272,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M81 90V90C97.8366 67.4342 131.893 67.6383 149 90V90",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M192 90V90C208.837 67.4342 242.893 67.6383 260 90V90",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5133 187H269.672C280.717 187 289.754 196.174 285.963 206.549C276.752 231.754 248.492 262 180.672 262C111.613 262 86.2911 230.641 79.82 205.174C77.2644 195.118 86.137 187 96.5133 187Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M147 190V255.5M221 190.5V255.5",
    stroke: "black",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappyPuffuIcon);
export default __webpack_public_path__ + "static/media/happyPuffuIcon.4fed5489b2a092c9bdfb9ad3d88cb56f.svg";
export { ForwardRef as ReactComponent };